// NATIVE 
import React, { useEffect } from 'react';


// CUSTOM 
import { Avatar, Card, CardActionArea, CardMedia } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deepOrange } from '@mui/material/colors';



// INSTALLED 
import { getImageStore } from '../store/files';




export const CardActionImage = ({ urlImage, typeImage }: any) => {


     // DISPATCH 
     const dispatch = useDispatch();


    // USE STATES
    const [logoUrl, setLogoUrl] = React.useState('');



    const getLogoImage = async(imageName:string) => { 
    
          const response =  await dispatch( getImageStore(imageName, typeImage) );

           if ( response instanceof Blob) {
              const imageUrl = URL.createObjectURL(response);
              setLogoUrl(imageUrl);
           }
 
    }


    useEffect(() => {
        getLogoImage(urlImage);
    }, [urlImage]);
    

  return (
    <>
    <Card sx={{ width: 350, marginTop: 5 }}>
        <CardActionArea>
            <CardMedia
            component="img"
            height="250"
            sx={{ objectFit: 'fill' }}
            image={logoUrl}
            alt="Q"
            />
        </CardActionArea>
    </Card>
        
    </>
  )
}
